import clsx from 'clsx';
import React from 'react';

import classes from './Tag.module.scss';

const TagVariant = {
    Danger: 'danger'
} as const;

type TagVariant = (typeof TagVariant)[keyof typeof TagVariant];

interface TagProps {
    variant?: TagVariant;
    children?: React.ReactNode;
    className?: string;
}

export const Tag: React.FC<TagProps> = ({ variant = TagVariant.Danger, ...props }) => {
    return (
        <div className={clsx(classes.root, { [classes[variant]]: variant }, props.className)}>
            {props.children}
        </div>
    );
};
